import React from 'react';
import PropTypes from 'prop-types';

import ReactResizeDetector from 'react-resize-detector';

class QA extends React.Component {
  constructor(props) {
    super(props);

    this.repositionContent = this.repositionContent.bind(this);
  }

  componentDidMount() {
    this.navbarEl = document.getElementsByClassName('navbar')[0];
    this.footerEl = document.getElementsByClassName('footer')[0];

    // For Jest testing purposes; it won't exist in the JSDOM
    if (!this.qaLayoutEl) { return; }

    if (!this.qaLayoutEl.classList.contains('qa-layout--fixed')) {
      window.addEventListener('scroll', this.repositionContent);
      this.repositionContent();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.repositionContent);
  }

  render() {
    return (
      <div
        ref={el => this.qaLayoutEl = el}
        className={`${this.props.className} qa-layout`}>
        <ReactResizeDetector handleHeight onResize={this.repositionContent.bind(this)} />

        { this.props.completionPercentage !== undefined &&
          <span className="qa-layout__progress-bar" style={{width: `${this.props.completionPercentage}%`}} />
        }

        <div className="qa-layout__top" ref={el => this.topEl = el}>
          { this.props.top }
        </div>

        <div className="qa-layout__sidebar" ref={el => this.sidebarEl = el}>
          <div className="container">
            { this.props.sidebar }
          </div>
        </div>

        <div className="qa-layout__content">
          <div className="container">
            { this.props.content }
          </div>
        </div>
      </div>
    );
  }

  repositionContent() {
    if (window.innerHeight === this.footerEl.offsetTop) { return; }
    if (window.innerHeight === this.footerEl.offsetTop - 1) { return; }

    const qaLayoutOffsetTop = this.qaLayoutEl.offsetTop;
    const footerDistanceToTop = this.footerEl.offsetTop - window.scrollY;
    const scrollPosition = window.scrollY;
    const topHeight = parseInt(window.getComputedStyle(this.topEl).height);

    if (scrollPosition < qaLayoutOffsetTop) {
      this.sidebarEl.style.position = 'absolute';
      this.sidebarEl.style.top = topHeight + 'px';
      this.sidebarEl.style.height = window.innerHeight + scrollPosition - qaLayoutOffsetTop + 'px';
    } else {
      if (footerDistanceToTop - window.innerHeight <= 0) {
        this.sidebarEl.style.position = 'absolute';
        this.sidebarEl.style.height = window.innerHeight - topHeight + 'px';
        this.sidebarEl.style.bottom = '0';

        if (topHeight > 0) {
          this.sidebarEl.style.top = topHeight + 'px';
        } else {
          this.sidebarEl.style.top = 'unset';
        }
      } else {
        this.sidebarEl.style.position = 'fixed';
        this.sidebarEl.style.top = '0';
        this.sidebarEl.style.bottom = 'unset';
        this.sidebarEl.style.height = window.innerHeight + 'px';
      }
    }
  }
}


QA.defaultProps = {
  className: '',
  completionPercentage: undefined
};

QA.propTypes = {
  className: PropTypes.string,
  top: PropTypes.element,
  sidebar: PropTypes.element.isRequired,
  content: PropTypes.element.isRequired,
  completionPercentage: PropTypes.number
};

export default QA;
